const keyMap: Record<string, string> = {
  "Backspace": "DEL",
  "Tab": "TAB",
  'Enter': 'ENTER',
  'ShiftLeft': 'SHIFT_LEFT',
  'ShiftRight': 'SHIFT_RIGHT',
  'ControlLeft': 'CTRL_LEFT',
  'ControlRight': 'CTRL_RIGHT',
  'AltLeft': 'ALT_LEFT',
  'AltRight': 'ALT_RIGHT',
  'CapsLock': 'CAPS_LOCK',
  'Space': 'SPACE',
  ' ': 'SPACE',
  'PageUp': 'PAGE_UP',
  'PageDown': 'PAGE_DOWN',
  'End': 'MOVE_END',
  'Home': 'MOVE_HOME',
  'ArrowLeft': 'DPAD_LEFT',
  'ArrowUp': 'DPAD_UP',
  'ArrowRight': 'DPAD_RIGHT',
  'ArrowDown': 'DPAD_DOWN',
  'Insert': 'INSERT',
  'Delete': 'DEL',
  'Fn': 'FUNCTION',
  'MetaLeft': 'META_LEFT',
  'MetaRight': 'META_RIGHT',
  'NumLock': 'NUM_LOCK',
  'ScrollLock': 'SCROLL_LOCK',
  'Symbol': 'SYM',
  'Clear': 'CLEAR',
  'Accept': 'DPAD_CENTER',
  'ContextMenu': 'MENU',
  'Escape': 'ESCAPE',
  'Help': 'HELP',
  'Pause': 'BREAK',
  'Select': 'BUTTON_SELECT',
  'ZoomIn': 'ZOOM_IN',
  'ZoomOut': 'ZOOM_OUT',
  'BrightnessDown': 'BRIGHTNESS_DOWN',
  'BrightnessUp': 'BRIGHTNESS_UP',
  'Eject': 'MEDIA_EJECT',
  'Power': 'POWER',
  'PrintScreen': 'SYSRQ',
  'Standby': 'SLEEP',
  'WakeUp': 'WAKEUP',
  'Convert': 'HENKAN',
  'GroupNext': 'LANGUAGE_SWITCH',
  'ModeChange': 'WITCH_CHARSET',
  'NonConvert': 'MUHENKAN',
  'Eisu': 'EISU',
  'HiraganaKatakana': 'KATAKANA_HIRAGANA',
  'KanjiMode': 'KANA',
  'ZenkakuHanaku': 'ZENKAKU_HANKAKU',
  'AppSwitch': 'APP_SWITCH',
  'Call': 'CALL',
  'Camera': 'CAMERA',
  'CameraFocus': 'FOCUS',
  'EndCall': 'ENDCALL',
  'GoBack': 'BACK',
  'GoHome': 'HOME',
  'HeadsetHook': 'HEADSETHOOK',
  'Notification': 'NOTIFICATION',
  'MannerMode': 'MANNER_MODE',
  'VoiceDial': 'VOICE_ASSIST',
  'ChannelDown': 'CHANNEL_DOWN',
  'ChannelUp': 'CHANNEL_UP',
  'MediaFastForward': 'MEDIA_FAST_FORWARD',
  'MediaPause': 'MEDIA_PAUSE',
  'MediaPlay': 'MEDIA_PLAY',
  'MediaPlayPause': 'MEDIA_PLAY_PAUSE',
  'MediaRecord': 'MEDIA_RECORD',
  'MediaRewind': 'MEDIA_REWIND',
  'MediaStop': 'MEDIA_STOP',
  'MediaTrackNext': 'MEDIA_NEXT',
  'MediaTrackPrevious': 'MEDIA_PREVIOUS',
  'AudioVolumeDown': 'VOLUME_DOWN',
  'AudioVolumeMute': 'VOLUME_MUTE',
  'AudioVolumeUp': 'VOLUME_UP',
  'MicrophoneVolumeMute': 'MUTE',
  'AVRInput': 'AVR_INPUT',
  'AVRPower': 'AVR_POWER',
  'ColorF0Red': 'PROG_RED',
  'ColorF1Green': 'PROG_GREEN',
  'ColorF2Yellow': 'PROG_YELLOW',
  'ColorF3Blue': 'PROG_BLUE',
  'ColorF4Grey': 'PROG_GREY',
  'ColorF5Brown': 'PROG_BROWN',
  'ClosedCaptionToggle': 'CAPTIONS',
  'Guide': 'GUIDE',
  'Info': 'INFO',
  'MediaAudioTrack': 'MEDIA_AUDIO_TRACK',
  'MediaLast': 'LAST_CHANNEL',
  'MediaSkipBackward': 'MEDIA_SKIP_BACKWARD',
  'MediaSkipForward': 'MEDIA_SKIP_FORWARD',
  'MediaStepBackward': 'MEDIA_STEP_BACKWARD',
  'MediaStepForward': 'MEDIA_SKIP_FORWARD',
  'MediaTopMenu': 'MEDIA_TOP_MENU',
  'NavigateIn': 'NAVIGATE_IN',
  'NavigateNext': 'NAVIGATE_NEXT',
  'NavigateOut': 'NAVIGATE_OUT',
  'NavigatePrevious': 'NAVIGATE_PREVIOUS',
  'Pairing': 'PAIRING',
  'Settings': 'SETTINGS',
  'STBInput': 'STB_INPUT',
  'STBPower': 'STB_POWER',
  'Subtitle': 'CAPTIONS',
  'Teletext': 'TV_TELETEXT',
  'ZoomToggle': 'TV_ZOOM_MODE',
  'Close': 'MEDIA_CLOSE',
  'LaunchCalculator': 'CALCULATOR',
  'LaunchCalendar': 'CALENDAR',
  'LaunchContacts': 'CONTACTS',
  'LaunchMail': 'ENVELOPE',
  'LaunchMusicPlayer': 'MUSIC',
  'LaunchWebBrowser': 'EXPLORER',
  'BrowserBack': 'BACK',
  'BrowserFavorites': 'BOOKMARK',
  'BrowserForward': 'FORWARD',
  'BrowserHome': 'HOME',
  'BrowserSearch': 'SEARCH',
  'Separator': 'NUMPAD_COMMA'
}

const twowayKey = ['Shift', 'Control', 'Alt', 'Meta']

export const mapAndroidKey = (event: KeyboardEvent) => {
  let { code, key } = event || {}
  if (!code && !key) return
  if (twowayKey.includes(key)) return keyMap[code]
  if (keyMap[key]) return keyMap[key]
  if ((/[a-z]/).test(key) && key) return key.toUpperCase()
  return key
}